import { observer } from "mobx-react-lite";
import { SubHeading } from "../../../components/Typography";
import { useStore } from "../../../stores/store";
import { useState, useEffect } from "react";
import { Tooltip, Checkbox, FormControlLabel, Select, MenuItem, CircularProgress, InputLabel, Button } from '@mui/material';
import { useTranslation } from "react-i18next";

function ExportConsentFiles() {
    const { t } = useTranslation();
    const {
        institutionStore: { selectedUserInstitution },
        dataExportStore: { getConsentFiles },
        masterDataStore: { getHealthInsuranceOptions, healthInsuranceOptionsList },
        loadingStore: { isLoading }
    } = useStore();
    const [downloadAll, setDownloadAll] = useState(true);
    const [selectedInsurance, setSelectedInsurance] = useState('');

    const exportConsentFiles = async () => {
        if (!selectedUserInstitution) return;
        try {
            const data = await getConsentFiles(
                selectedUserInstitution.institutionId,
                !downloadAll ? selectedInsurance : undefined
            );

            const blob = new Blob([data], { type: "application/zip" });

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'InformConsents.zip');
            document.body.appendChild(link);

            link.click();

            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error("Error exporting data:", error);
        }
    };

    useEffect(() => {
        if (healthInsuranceOptionsList.length === 0) {
            getHealthInsuranceOptions();
        }
    }, []);

    useEffect(() => {
        if (healthInsuranceOptionsList.length > 0 && !selectedInsurance) {
            setSelectedInsurance(healthInsuranceOptionsList[0].name ?? "");
        }
    }, [healthInsuranceOptionsList, selectedInsurance]);


    if (isLoading(getHealthInsuranceOptions)) {
        return <CircularProgress />
    }

    return (
        <>
            <SubHeading>EXPORT_CONSENT_FILES</SubHeading>
            <div style={{ margin: '30px 0px' }}>
                <div style={{ margin: '10px 0px' }}>
                    <Tooltip title={t("EXPORT_CONSENT_FILES_DOWNLOAD_ALL_TOOLTIP")}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={downloadAll}
                                    onChange={(e) => setDownloadAll(e.target.checked)}
                                />
                            }
                            label={t("DOWNLOAD_ALL_CONSENT_FILES")}
                        />
                    </Tooltip>
                </div>
                <div style={{ margin: '10px 0px' }}>
                    <InputLabel sx={{ fontSize: "14px", color: downloadAll ? 'gray' : 'black' }}>{t("FILTER_BY_HEALTH_INSURANCE")}</InputLabel>
                    <Select
                        fullWidth
                        disabled={downloadAll}
                        value={selectedInsurance}
                        onChange={(e) => setSelectedInsurance(e.target.value)}
                    >
                        {healthInsuranceOptionsList
                            .map((option) => (
                                <MenuItem value={option.name!} key={option.name} sx={{ fontSize: "14px" }}>
                                    {option.name}
                                </MenuItem>
                            ))}
                    </Select>
                </div>
            </div>
            <div>
                <p style={{ fontSize: '13px', color: 'slategray' }}>
                    {downloadAll
                        ? t('CONSENT_DOWNLOAD_ALL_CONFIRMATION')
                        : t('CONSENT_DOWNLOAD_FILTERED_CONFIRMATION', { insurance: selectedInsurance })}
                </p>
                <Button
                    fullWidth
                    variant="contained"
                    onClick={exportConsentFiles}
                    disabled={isLoading(getConsentFiles) || !downloadAll && !selectedInsurance}
                >
                    {isLoading(getConsentFiles) ? `${t("DOWNLOADING")}...` : t("DOWNLOAD_FILES")}
                </Button>
            </div>
        </>
    )
}

export default observer(ExportConsentFiles);